import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './EventList.css';
import getEventUrl from '../../../../../../../../functions/getEventUrl';
import {LIVE_DOMAIN, TICK_DOMAIN} from '../../../../../../../../config/config';
import {copy} from '../../../../../../../../assets/symbols/symbols/Symbols.css';

interface EventListProps {
    events: any[];
}

function EventList({events}: EventListProps) {
    const {t} = useTranslation('promotionMessage');

    if(events.length === 0) {
        return (
            <css.eventList>
                <css.event>{t('noEvents')}</css.event>
            </css.eventList>
        );
    }

    return (
        <css.eventList>
            {events.map((event, index) => (
                <css.event key={index}>
                    <css.link
                        href={`/e/${event.eid}/realtime`}
                        target="_blank"
                    >
                        <css.circle />
                        <css.shareIcon $icon={copy} />
                        {event.title}
                    </css.link>
                </css.event>
            ))}
        </css.eventList>
    );
}

export default EventList; 